import Vue from 'vue'
import Router from 'vue-router'

const indexPage = r => require.ensure([], () => r(require('./pages/index/index.vue')), 'index');
const blendPage = r => require.ensure([], () => r(require('./pages/blendpage.vue')), 'blendpage');
const orderPage = r => require.ensure([], () => r(require('./pages/order/order.vue')), 'order');
const orderSuccessPage = r => require.ensure([], () => r(require('./pages/orderSuccess/orderSuccess.vue')), 'orderSuccess');
Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '首页',
      component: indexPage
    },
    {
      path: '/blend',
      name: '拼图',
      component: blendPage
    },
    {
      path: '/order',
      name: '预约拍摄',
      component: orderPage,
      meta: {
        title: "预约",
      }
    },
    {
      path: '/orderSuccess',
      name: '预约成功',
      component: orderSuccessPage
    }
  ]
});

/**
 * 全局路由钩子，不使用可删除
 */
router.beforeEach((to, from, next) => {
  if(to.path.indexOf("&gid") != -1){
    next("/")
  } else {
    next()
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router.js